var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Frown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,17.7989899 6.20101013,22.5 12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,6.20101013 17.7989899,1.5 12,1.5 Z",
    id: "Mask",
    fill: "#F54444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1472948,12.0008377 C17.9743515,14.7904131 15.2159246,16.7491937 12,16.7491937 C8.78407538,16.7491937 6.0256485,14.7904131 4.85270518,12.0008377 L6.51617701,12 C7.57805125,13.9364049 9.63571649,15.2491937 12,15.2491937 C14.3642835,15.2491937 16.4219488,13.9364049 17.483823,12 Z",
    id: "Combined-Shape",
    fill: "#F54444",
    fillRule: "nonzero",
    transform: "translate(12.000000, 14.374597) scale(1, -1) translate(-12.000000, -14.374597) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F54444",
    cx: 8.5,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#F54444",
    cx: 15.5,
    cy: 8.5,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrown);
export default __webpack_public_path__ + "static/media/frown.93c4b3c92b2d30b117da7fa099d79b3d.svg";
export { ForwardRef as ReactComponent };